import type { DisplayText } from "./dto/DisplayText.js"
import es from "./es.js"

/**
 * @description
 *	Dictionary for es-CL locale. Inherits the Spanish base as is, like every
 *	Spanish locale; the base tells why they all read the same.
 */
const esCL: DisplayText = { ...es }

export default esCL
